import Head from "next/head";

import { SeoProductMeta } from "./types";

interface SeoTagsProps {
  meta: SeoProductMeta;
}

const SeoTags = ({ meta }: SeoTagsProps) => {
  return (
    <Head>
      <title>{meta.title}</title>
      <meta name="title" content={meta.title} />
      <meta name="description" content={meta.description} />
      {meta.keywords && <meta name="keywords" content={meta.keywords} />}

      <meta property="og:locale" content="ru_RU" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={meta.title} />
      {meta.image && <meta property="og:image" content={meta.image} />}
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={meta.url} />
      <meta property="og:site_name" content="Look Online" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="lookonline.ru" />
      <meta property="twitter:url" content={meta.url} />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={meta.image} />
    </Head>
  );
};

export default SeoTags;
